import { CircularProgress } from "@mui/material";
import React, { useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import create_template from "../../Assets/Images/create_template.svg";
import imageIcon from "../../Assets/Images/imageIcon.svg";
import "../../Assets/Styles/pages/landing.scss";
import PickImage from "../../Components/PickImage/pickImage";
import SelectTemplate from "../../Components/SelectTemplate/selectTemplate";
import TemplateListSlider from "../../Components/TemplateListSlider/templateListSlider";
import UploadImage from "../../Components/UploadImage/uploadImage";
import {
  ClearCache,
  setBatchImages,
  setEdit_Template,
} from "../../Redux/UserSlice/userSlice";
import { deleteAll } from "../../Redux/WaterMarks/wateramarks";
import { GetSettings } from "../../actions/Settings/Setting";
import { GetAllTemplates } from "../../actions/Template/Template";
import { ClearImage } from "../../Redux/MainImage/imageSlice";

const Home = () => {
  const { t } = useTranslation();
  const [openImage, setOpenImage] = useState(false);
  const [openTemplate, setOpenTemplate] = useState(false);
  const [portraitTemp, setPortrait] = useState(null);
  const [landcsapeTemp, setLandcsape] = useState(null);

  const dispatch = useDispatch();

  const authSliceState = useSelector((state) => state["authSlice"]);
  const userSliceState = useSelector((state) => state["userSlice"]);
  const file = useSelector((state) => state.mainImage);
  let loader = file.loader;

  const history = useHistory();
  const handleTemplateUpdate = () => {
    if (authSliceState.auth_token)
      Promise.all([dispatch(GetAllTemplates()), dispatch(GetSettings())]);
  };

  useEffect(() => {
    const handlePopstate = (event) => {
      event.preventDefault();
      dispatch(ClearCache());
    };

    window.addEventListener("popstate", handlePopstate);

    return () => {
      window.removeEventListener("popstate", handlePopstate);
    };
  }, []);

  useEffect(() => {
    const handlePopState = () => {
      history.push("/home");
    };

    window.addEventListener("popstate", handlePopState);

    return () => {
      window.removeEventListener("popstate", handlePopState);
    };
  }, [history]);

  const currentUrl = history.location.pathname;

  useEffect(() => {
    var editPageAdress = currentUrl === "/addtemplate";
    dispatch(setEdit_Template(editPageAdress));
  }, [currentUrl, dispatch]);

  useEffect(() => {
    if (!Object.keys(userSliceState.user_Auth).length) history.push("/home");
  }, []);

  const handleOpen = (component) => {
    handleTemplateUpdate();
    if (component === true) setOpenTemplate(!openTemplate);
    else {
      if (Object.keys(userSliceState.user_Auth).length)
        history.push("/addtemplate");
      else history.push("/home");
    }
  };
  const handleClean = () => {
    setPortrait(null);
    setLandcsape(null);
    setOpenImage(false);
    dispatch(setBatchImages(false));
    dispatch(deleteAll());
    dispatch(ClearImage());
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    const handleClean = () => {
      dispatch(setBatchImages(false));
      dispatch(deleteAll());
      dispatch(ClearImage());
    };

    handleClean();
  }, []);

  return (
    <>
      {loader && (
        <div className="circular-progress-bar">
          <CircularProgress className="themeColor" />
        </div>
      )}
      <Col className="landing">
        <Row
          className={`upload 
         m-0 p-0 align-items-start`}
        >
          <Row className="m-0 p-0">
            <Col
              md={12}
              className="upload_image mb-107px d-flex flex-column
           justify-content-center align-items-center h-100
           m-0 p-0"
            >
              {/* {!!!(userSliceState.edit_Template) && */}
              <Col className="w-100 productSans text-center line_height_100pc mt-107px text_70">
                {t("lang.ezywatermark")}
              </Col>
              {!userSliceState.edit_Template ? (
                <Col className="w_60_xl productSansLight line_height_1_688 text_18 details text-center mt-3 mb-3 pb-3">
                  {t("lang.ezywatermark_detail")}
                </Col>
              ) : (
                <Col className="productSansLight details text-center my-4 d-flex flex-column justify-content-center  text_18">
                  {t("editTemplate_detail")}
                </Col>
              )}
              <PickImage
                setOpen={setOpenImage}
                edit={userSliceState.edit_Template}
              />
              {Object.keys(userSliceState.user_Auth).length &&
              !userSliceState.edit_Template ? (
                <>
                  <Row
                    onClick={() => handleOpen(true)}
                    className="upload_multiple w_38 w_xl_30 py-Large-4 py-3 pointer d-flex justify-content-center align-items-center m-0 mt-3"
                  >
                    <img
                      src={imageIcon}
                      alt={"imageIcon"}
                      className="size_30x30 p-0"
                    />
                    <div className="text-white productSansLight w_max my-1 text_18 p-0 ms-2 px-1">
                      {t("lang.WatermarkMulitple")}
                    </div>
                  </Row>
                  <Row
                    onClick={() => handleOpen(false)}
                    className="create_template w_38 w_xl_30 py-3 py-Large-4 pointer d-flex justify-content-center align-items-center m-0 mt-3"
                  >
                    <img
                      src={create_template}
                      alt={"create_template"}
                      className="size_30x30 p-0"
                    />
                    <div className="text-white productSansLight my-1 w_max text_18 p-0 ms-2 px-1">
                      {t("lang.CreateTemplate")}
                    </div>
                  </Row>
                </>
              ) : null}
              {userSliceState.edit_Template ? <TemplateListSlider /> : null}
            </Col>
          </Row>
        </Row>
      </Col>
      <UploadImage
        open={openImage}
        setOpen={setOpenImage}
        multiple={portraitTemp || landcsapeTemp ? true : false}
        choice={0}
        parent={true}
        handleClean={handleClean}
      />
      <SelectTemplate
        open={openTemplate}
        setOpen={setOpenTemplate}
        portraitTemp={portraitTemp}
        setPortrait={setPortrait}
        landcsapeTemp={landcsapeTemp}
        setLandcsape={setLandcsape}
        setOpenUploadImage={setOpenImage}
      />
    </>
  );
};

export default Home;
